import { Grid, styled } from "@mui/material";

export const StretchedCardContainer = styled(Grid)(() => ({
  "& .MuiBox-root": {
    height: "100%",
    "& .MuiPaper-root": {
      height: "100%"
    }
  }
}));
